<template>
  <section>
    <ChooseTmpl
      ref="chooseTmpl"
      title="选择油站"
      :resultVal="resultVal"
      :isRadio="isRadio"
      :otherSearchData="otherSearchData"
      :searchBoxDataTmpl="searchBoxDataTmpl"
      :getListApi="getListApi"
      :tableTitle="tableTitle"
      :tableSelectTar="tableSelectTar"
      :showTableTitle="showTableTitle"
      :handleSearchData="handleSearchData"
      @change="handleResultChange"
      :customShow="customShow"
      :showName="showName"
      :clearable="clearable"
    >
      <section slot="tableSlot" slot-scope="scope">
        <section>{{scope.row[scope.column.property]}}</section>
      </section>
    </ChooseTmpl>
  </section>
</template>

<script>
import {
  getLineOilDepotSchemeByLineId,
} from 'api/operate';
import ChooseTmpl from 'components/choose/tmpl/tmpl.vue';
export default {
  components: {
    ChooseTmpl,
  },
  model: {
    prop: 'resultVal', // 父级传进来的值
    event: 'change',
  },
  props: {
    clearable: { // 清除按钮
      type: Boolean,
      default: false,
    },
    resultVal: {
      default: '',
    },
    isRadio: {
      type: Boolean,
      default: false,
    },
    otherSearchData: {
      type: Object,
      default: () => ({}),
    },
    customShow: { // 是否自定义展示结果
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      showName: 'oilName',
      tableSelectTar: 'oilId',
      searchBoxDataTmpl: {
        form: [
          { // 推荐油站
            label: '选择油站',
            value: 'type',
            type: 'select',
            default: '2',
            placeholder: '请选择出险时间',
            options: [
              { label: '所有油站', value: '2' },
              { label: '推荐油站', value: '1' },
            ],
          },
          { // 油站名称
            label: '油站名称',
            value: 'productName',
            type: 'input',
            placeholder: '请输入油站名称',
          },
        ],
      },
      showTableTitle: [],
      tableTitle: [
        {
          prop: 'oilName',
          label: '油站名称',
        },
        {
          prop: 'oilPrice',
          label: '单价',
        },
        {
          prop: 'oilPhone',
          label: '油站电话',
        },
        {
          prop: 'serviceName',
          label: '服务商名称',
        },
        {
          prop: 'address',
          label: '地址',
        },
        {
          prop: 'distance',
          label: '距离靠台地',
        },
      ],
    };
  },
  methods: {
    getListApi: getLineOilDepotSchemeByLineId,
    handleResultChange (val) {
      this.$emit('change', val);
    },
    handleSearchData (searchBoxData) {
      return searchBoxData;
    },
    show () {
      this.$refs.chooseTmpl.show();
    },
  },
};
</script>

<style>
</style>
